// Hierarchical query keys for the journal domain (TanStack).
// Company-scoping is mandatory — the key is the only isolation boundary on a
// company switch (see src/domain/CLAUDE.md). Always invalidate via this factory,
// never a hand-typed literal.
export const journalKeys = {
  all: ['journal'] as const,
  // The cell name and its current value belong in the key because the read
  // answers differently for each — a blank value asks for the create form, a set
  // one for that row's.
  indexForm: (companyId: string | null, documentID: string, cellName: string, cellValue: string) =>
    [...journalKeys.all, 'indexForm', companyId, documentID, cellName, cellValue] as const,
};
